module.exports = "https://static.wanderu.com/static/media/chiku.4cada793.svg";